import { Card, Icon, SupportedIcon } from 'corso-admin-ui';
import { formatter } from 'corso-web-lib';

export default function MetricCard({
  icon,
  label,
  value,
  unit,
}: {
  icon: SupportedIcon;
  label: string;
  value: string | number | null;
  unit?: string;
}) {
  const formattedValue =
    // oxlint-disable-next-line no-nested-ternary
    value != null
      ? typeof value === 'number'
        ? formatter.count(value)
        : value
      : '—';
  const valueString = value != null ? `${formattedValue}${unit ?? ''}` : '—';

  return (
    <Card flat>
      <div className="flex items-center justify-between gap-1">
        <p className="text-xs font-medium text-neutral-500 uppercase">
          {label}
        </p>
        <div className="aspect-square shrink-0 rounded-lg bg-corso-blue-50 p-1.5">
          <Icon icon={icon} className="size-5 text-corso-blue-600" />
        </div>
      </div>
      <p className="text-2xl font-bold text-neutral-900 tabular-nums">
        {valueString}
      </p>
    </Card>
  );
}
